export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "module_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reportes de calidad"])}
        }
      }
    }
  })
}